// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationLiabilitySelect_IntegrationLiabilityFragment = { __typename?: 'IntegrationLiability', id: string, integrationID: string, name: string, externalKind: Types.IntegrationLiabilityExternalKind, value?: CurrencyUSD | null, interestRate?: Percent | null, recurringPaymentAmount?: CurrencyUSD | null, paymentFrequency?: string | null, termStart?: Time | null, termEnd?: Time | null, recipientName?: string | null, integrationClient?: { __typename?: 'IntegrationClient', id: string, name: string } | null };

export type GetIntegrationLiabilitiesQueryVariables = Types.Exact<{
  optionsLike?: Types.InputMaybe<Types.IntegrationLiabilityWhereInput>;
  selectedOptionsLike?: Types.InputMaybe<Types.IntegrationLiabilityWhereInput>;
  first: Types.Scalars['Int']['input'];
}>;


export type GetIntegrationLiabilitiesQuery = { __typename?: 'Query', queryData: { __typename?: 'IntegrationLiabilityConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationLiabilityEdge', node?: (
        { __typename?: 'IntegrationLiability' }
        & IntegrationLiabilitySelect_IntegrationLiabilityFragment
      ) | null } | null> | null }, selectedData: { __typename?: 'IntegrationLiabilityConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationLiabilityEdge', node?: (
        { __typename?: 'IntegrationLiability' }
        & IntegrationLiabilitySelect_IntegrationLiabilityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetIntegrationLiabilities: 'GetIntegrationLiabilities' as const
  },
  Fragment: {
    IntegrationLiabilitySelect_IntegrationLiability: 'IntegrationLiabilitySelect_IntegrationLiability' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const IntegrationLiabilitySelect_IntegrationLiabilityFragmentDoc = gql`
    fragment IntegrationLiabilitySelect_IntegrationLiability on IntegrationLiability {
  id
  integrationID
  name
  externalKind
  value
  interestRate
  recurringPaymentAmount
  paymentFrequency
  termStart
  termEnd
  recipientName
  integrationClient {
    id
    name
  }
}
    `;
export const GetIntegrationLiabilitiesDocument = gql`
    query GetIntegrationLiabilities($optionsLike: IntegrationLiabilityWhereInput, $selectedOptionsLike: IntegrationLiabilityWhereInput, $first: Int!) {
  queryData: integrationLiabilities(where: $optionsLike, first: $first) {
    totalCount
    edges {
      node {
        ...IntegrationLiabilitySelect_IntegrationLiability
      }
    }
  }
  selectedData: integrationLiabilities(where: $selectedOptionsLike) {
    totalCount
    edges {
      node {
        ...IntegrationLiabilitySelect_IntegrationLiability
      }
    }
  }
}
    ${IntegrationLiabilitySelect_IntegrationLiabilityFragmentDoc}`;

/**
 * __useGetIntegrationLiabilitiesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationLiabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationLiabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationLiabilitiesQuery({
 *   variables: {
 *      optionsLike: // value for 'optionsLike'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetIntegrationLiabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>(GetIntegrationLiabilitiesDocument, withFetchPolicyContext(options));
      }
export function useGetIntegrationLiabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>(GetIntegrationLiabilitiesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIntegrationLiabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>(GetIntegrationLiabilitiesDocument, withFetchPolicyContext(options));
        }
export type GetIntegrationLiabilitiesQueryHookResult = ReturnType<typeof useGetIntegrationLiabilitiesQuery>;
export type GetIntegrationLiabilitiesLazyQueryHookResult = ReturnType<typeof useGetIntegrationLiabilitiesLazyQuery>;
export type GetIntegrationLiabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationLiabilitiesSuspenseQuery>;
export type GetIntegrationLiabilitiesQueryResult = Apollo.QueryResult<GetIntegrationLiabilitiesQuery, GetIntegrationLiabilitiesQueryVariables>;